import {Component, Injector} from "@angular/core";
import {AppComponentBase} from "../../../services/AppComponentBase";
import {NgbActiveModal, NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ProvidersList, Providers} from "../../../enums/providers";


@Component({
    selector: "open-live-account",
    template: require('./open-live-account.component.html'),
    styles: [require('./open-live-account.component.css')]
})

export class OpenLiveAccountModal extends AppComponentBase  {

	public providerlist = ProvidersList();
	public Providers = Providers
	public getProviderData(value: Providers) {
		let current = this.providerlist.filter(v => {
		  return v.id == value;
		})
	
		return current[0];
	  }

	private _modeOpen: boolean = true;
	public get modeOpen(): boolean {
		return this._modeOpen;
	}
	public set modeOpen(value: boolean) {
		this._modeOpen = value;
	}



	

    constructor(
       
        public activeModal: NgbActiveModal,
        
        injector: Injector,
    ) {
        super(injector);
    }

    public isUsZone:boolean = false;

    public listCountries = Countries;
    public onChange(e:any){
        if(e)
        {
            //USA, Canada
            if(e.id=="Canada" || e.id=="United States")
            {
                this.isUsZone = true;
            }
            else
            {
                this.isUsZone = false;
            }
        }
    }

    private _selectedCountry?: string ;
    public get selectedCountry(): string | undefined {
        return this._selectedCountry;
    }
    public set selectedCountry(value: string | undefined) {
        this._selectedCountry = value;
    }
}

export function ShowOpenLiveAccountModal(modalService: NgbModal){
    let m:NgbModalRef= modalService.open(OpenLiveAccountModal,{
        backdrop: "static",
        size: "sm",
        centered: true, 
        windowClass: "dark-modal"
    });
    let modal = (<OpenLiveAccountModal>m.componentInstance);
    
    return modal

}


export const Countries=[
    
	{id:"United States", label:"United States"},
	{id:"Afghanistan", label:"Afghanistan"},
	{id:"Albania", label:"Albania"},
	{id:"Algeria", label:"Algeria"},
	{id:"American Samoa", label:"American Samoa"},
	{id:"Andorra", label:"Andorra"},
	{id:"Angola", label:"Angola"},
	{id:"Anguilla", label:"Anguilla"},
	{id:"Antigua and Barbuda", label:"Antigua and Barbuda"},
	{id:"Argentina", label:"Argentina"},
	{id:"Armenia", label:"Armenia"},
	{id:"Aruba", label:"Aruba"},
	{id:"Australia", label:"Australia"},
	{id:"Austria", label:"Austria"},
	{id:"Azerbaijan", label:"Azerbaijan"},
	{id:"Bahamas", label:"Bahamas"},
	{id:"Bahrain", label:"Bahrain"},
	{id:"Bangladesh", label:"Bangladesh"},
	{id:"Barbados", label:"Barbados"},
	{id:"Belarus", label:"Belarus"},
	{id:"Belgium", label:"Belgium"},
	{id:"Belize", label:"Belize"},
	{id:"Benin", label:"Benin"},
	{id:"Bermuda", label:"Bermuda"},
	{id:"Bhutan", label:"Bhutan"},
	{id:"Bolivia", label:"Bolivia"},
	{id:"Bosnia-Herzegovina", label:"Bosnia-Herzegovina"},
	{id:"Botswana", label:"Botswana"},
	{id:"Bouvet Island", label:"Bouvet Island"},
	{id:"Brazil", label:"Brazil"},
	{id:"Brunei", label:"Brunei"},
	{id:"Bulgaria", label:"Bulgaria"},
	{id:"Burkina Faso", label:"Burkina Faso"},
	{id:"Burundi", label:"Burundi"},
	{id:"Cambodia", label:"Cambodia"},
	{id:"Cameroon", label:"Cameroon"},
	{id:"Canada", label:"Canada"},
	{id:"Cape Verde", label:"Cape Verde"},
	{id:"Cayman Islands", label:"Cayman Islands"},
	{id:"Central African Republic", label:"Central African Republic"},
	{id:"Chad", label:"Chad"},
	{id:"Chile", label:"Chile"},
	{id:"China", label:"China"},
	{id:"Christmas Island", label:"Christmas Island"},
	{id:"Cocos (Keeling) Islands", label:"Cocos (Keeling) Islands"},
	{id:"Colombia", label:"Colombia"},
	{id:"Comoros", label:"Comoros"},
	{id:"Congo", label:"Congo"},
	{id:"Democratic Republic of the (Zaire)", label:"Democratic Republic of the (Zaire)"},
	{id:"Republic of", label:"Republic of"},
	{id:"Cook Islands", label:"Cook Islands"},
	{id:"Costa Rica", label:"Costa Rica"},
	{id:"Croatia", label:"Croatia"},
	{id:"Cuba", label:"Cuba"},
	{id:"Cyprus", label:"Cyprus"},
	{id:"Czech Republic", label:"Czech Republic"},
	{id:"Denmark", label:"Denmark"},
	{id:"Djibouti", label:"Djibouti"},
	{id:"Dominica", label:"Dominica"},
	{id:"Dominican Republic", label:"Dominican Republic"},
	{id:"Ecuador", label:"Ecuador"},
	{id:"Egypt", label:"Egypt"},
	{id:"El Salvador", label:"El Salvador"},
	{id:"Equatorial Guinea", label:"Equatorial Guinea"},
	{id:"Eritrea", label:"Eritrea"},
	{id:"Estonia", label:"Estonia"},
	{id:"Ethiopia", label:"Ethiopia"},
	{id:"Falkland Islands", label:"Falkland Islands"},
	{id:"Faroe Islands", label:"Faroe Islands"},
	{id:"Fiji", label:"Fiji"},
	{id:"Finland", label:"Finland"},
	{id:"France", label:"France"},
	{id:"French Guiana", label:"French Guiana"},
	{id:"Gabon", label:"Gabon"},
	{id:"Gambia", label:"Gambia"},
	{id:"Georgia", label:"Georgia"},
	{id:"Germany", label:"Germany"},
	{id:"Ghana", label:"Ghana"},
	{id:"Gibraltar", label:"Gibraltar"},
	{id:"Greece", label:"Greece"},
	{id:"Greenland", label:"Greenland"},
	{id:"Grenada", label:"Grenada"},
	{id:"Guadeloupe (French)", label:"Guadeloupe (French)"},
	{id:"Guam (USA)", label:"Guam (USA)"},
	{id:"Guatemala", label:"Guatemala"},
	{id:"Guinea", label:"Guinea"},
	{id:"Guinea Bissau", label:"Guinea Bissau"},
	{id:"Guyana", label:"Guyana"},
	{id:"Haiti", label:"Haiti"},
	{id:"Holy See", label:"Holy See"},
	{id:"Honduras", label:"Honduras"},
	{id:"Hong Kong", label:"Hong Kong"},
	{id:"Hungary", label:"Hungary"},
	{id:"Iceland", label:"Iceland"},
	{id:"India", label:"India"},
	{id:"Indonesia", label:"Indonesia"},
	{id:"Iran", label:"Iran"},
	{id:"Iraq", label:"Iraq"},
	{id:"Ireland", label:"Ireland"},
	{id:"Israel", label:"Israel"},
	{id:"Italy", label:"Italy"},
	{id:"Ivory Coast (Cote D`Ivoire)", label:"Ivory Coast (Cote D`Ivoire)"},
	{id:"Jamaica", label:"Jamaica"},
	{id:"Japan", label:"Japan"},
	{id:"Jordan", label:"Jordan"},
	{id:"Kazakhstan", label:"Kazakhstan"},
	{id:"Kenya", label:"Kenya"},
	{id:"Kiribati", label:"Kiribati"},
	{id:"Kuwait", label:"Kuwait"},
	{id:"Kyrgyzstan", label:"Kyrgyzstan"},
	{id:"Laos", label:"Laos"},
	{id:"Latvia", label:"Latvia"},
	{id:"Lebanon", label:"Lebanon"},
	{id:"Lesotho", label:"Lesotho"},
	{id:"Liberia", label:"Liberia"},
	{id:"Libya", label:"Libya"},
	{id:"Liechtenstein", label:"Liechtenstein"},
	{id:"Lithuania", label:"Lithuania"},
	{id:"Luxembourg", label:"Luxembourg"},
	{id:"Macau", label:"Macau"},
	{id:"Macedonia", label:"Macedonia"},
	{id:"Madagascar", label:"Madagascar"},
	{id:"Malawi", label:"Malawi"},
	{id:"Malaysia", label:"Malaysia"},
	{id:"Maldives", label:"Maldives"},
	{id:"Mali", label:"Mali"},
	{id:"Malta", label:"Malta"},
	{id:"Marshall Islands", label:"Marshall Islands"},
	{id:"Martinique (French)", label:"Martinique (French)"},
	{id:"Mauritania", label:"Mauritania"},
	{id:"Mauritius", label:"Mauritius"},
	{id:"Mayotte", label:"Mayotte"},
	{id:"Mexico", label:"Mexico"},
	{id:"Micronesia", label:"Micronesia"},
	{id:"Moldova", label:"Moldova"},
	{id:"Monaco", label:"Monaco"},
	{id:"Mongolia", label:"Mongolia"},
	{id:"Montenegro", label:"Montenegro"},
	{id:"Montserrat", label:"Montserrat"},
	{id:"Morocco", label:"Morocco"},
	{id:"Mozambique", label:"Mozambique"},
	{id:"Myanmar", label:"Myanmar"},
	{id:"Namibia", label:"Namibia"},
	{id:"Nauru", label:"Nauru"},
	{id:"Nepal", label:"Nepal"},
	{id:"Netherlands", label:"Netherlands"},
	{id:"Netherlands Antilles", label:"Netherlands Antilles"},
	{id:"New Caledonia (French)", label:"New Caledonia (French)"},
	{id:"New Zealand", label:"New Zealand"},
	{id:"Nicaragua", label:"Nicaragua"},
	{id:"Niger", label:"Niger"},
	{id:"Nigeria", label:"Nigeria"},
	{id:"Niue", label:"Niue"},
	{id:"Norfolk Island", label:"Norfolk Island"},
	{id:"North Korea", label:"North Korea"},
	{id:"Northern Mariana Islands", label:"Northern Mariana Islands"},
	{id:"Norway", label:"Norway"},
	{id:"Oman", label:"Oman"},
	{id:"Pakistan", label:"Pakistan"},
	{id:"Palau", label:"Palau"},
	{id:"Panama", label:"Panama"},
	{id:"Papua New Guinea", label:"Papua New Guinea"},
	{id:"Paraguay", label:"Paraguay"},
	{id:"Peru", label:"Peru"},
	{id:"Philippines", label:"Philippines"},
	{id:"Pitcairn Island", label:"Pitcairn Island"},
	{id:"Poland", label:"Poland"},
	{id:"Polynesia (French)", label:"Polynesia (French)"},
	{id:"Portugal", label:"Portugal"},
	{id:"Puerto Rico", label:"Puerto Rico"},
	{id:"Qatar", label:"Qatar"},
	{id:"Reunion", label:"Reunion"},
	{id:"Romania", label:"Romania"},
	{id:"Russia", label:"Russia"},
	{id:"Rwanda", label:"Rwanda"},
	{id:"Saint Helena", label:"Saint Helena"},
	{id:"Saint Kitts and Nevis", label:"Saint Kitts and Nevis"},
	{id:"Saint Lucia", label:"Saint Lucia"},
	{id:"Saint Pierre and Miquelon", label:"Saint Pierre and Miquelon"},
	{id:"Saint Vincent and Grenadines", label:"Saint Vincent and Grenadines"},
	{id:"Samoa", label:"Samoa"},
	{id:"San Marino", label:"San Marino"},
	{id:"Sao Tome and Principe", label:"Sao Tome and Principe"},
	{id:"Saudi Arabia", label:"Saudi Arabia"},
	{id:"Senegal", label:"Senegal"},
	{id:"Serbia", label:"Serbia"},
	{id:"Seychelles", label:"Seychelles"},
	{id:"Sierra Leone", label:"Sierra Leone"},
	{id:"Singapore", label:"Singapore"},
	{id:"Slovakia", label:"Slovakia"},
	{id:"Slovenia", label:"Slovenia"},
	{id:"Solomon Islands", label:"Solomon Islands"},
	{id:"Somalia", label:"Somalia"},
	{id:"South Africa", label:"South Africa"},
	{id:"South Georgia and South Sandwich Islands", label:"South Georgia and South Sandwich Islands"},
	{id:"South Korea", label:"South Korea"},
	{id:"Spain", label:"Spain"},
	{id:"Sri Lanka", label:"Sri Lanka"},
	{id:"Sudan", label:"Sudan"},
	{id:"Suriname", label:"Suriname"},
	{id:"Svalbard and Jan Mayen Islands", label:"Svalbard and Jan Mayen Islands"},
	{id:"Swaziland", label:"Swaziland"},
	{id:"Sweden", label:"Sweden"},
	{id:"Switzerland", label:"Switzerland"},
	{id:"Syria", label:"Syria"},
	{id:"Taiwan", label:"Taiwan"},
	{id:"Tajikistan", label:"Tajikistan"},
	{id:"Tanzania", label:"Tanzania"},
	{id:"Thailand", label:"Thailand"},
	{id:"Timor-Leste (East Timor)", label:"Timor-Leste (East Timor)"},
	{id:"Togo", label:"Togo"},
	{id:"Tokelau", label:"Tokelau"},
	{id:"Tonga", label:"Tonga"},
	{id:"Trinidad and Tobago", label:"Trinidad and Tobago"},
	{id:"Tunisia", label:"Tunisia"},
	{id:"Turkey", label:"Turkey"},
	{id:"Turkmenistan", label:"Turkmenistan"},
	{id:"Turks and Caicos Islands", label:"Turks and Caicos Islands"},
	{id:"Tuvalu", label:"Tuvalu"},
	{id:"Uganda", label:"Uganda"},
	{id:"Ukraine", label:"Ukraine"},
	{id:"United Arab Emirates", label:"United Arab Emirates"},
	{id:"United Kingdom", label:"United Kingdom"},
	{id:"Uruguay", label:"Uruguay"},
	{id:"Uzbekistan", label:"Uzbekistan"},
	{id:"Vanuatu", label:"Vanuatu"},
	{id:"Venezuela", label:"Venezuela"},
	{id:"Vietnam", label:"Vietnam"},
	{id:"Virgin Islands", label:"Virgin Islands"},
	{id:"Wallis and Futuna Islands", label:"Wallis and Futuna Islands"},
	{id:"Yemen", label:"Yemen"},
	{id:"Zambia", label:"Zambia"},
	{id:"Zimbabwe", label:"Zimbabwe"},

]